// https://animate.style

const sections = document.querySelectorAll('[data-section-fade-in]');
const intersectionObserverExists = ('IntersectionObserver' in window);

const config = {
    // If the image gets within 50px in the Y axis, start the download.
    // rootMargin: '50px 0px',
    threshold: 0.25,
};

const doFadeIn = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
            // Stop watching and count the numbers
            observer.unobserve(entry.target);
            entry.target.classList.add('animate__fadeInUp');
        }
    });
};


// If we don't have support for intersection observer, load the images immediately
sections.forEach((el, i) => {
    // fade in the first item no matter what
    if (i === 0) {
        el.classList.add('animate__animated', 'animate__fadeIn');
    }
    else if (intersectionObserverExists) {
        el.classList.add('animate__animated');
        const observer = new IntersectionObserver(doFadeIn, config);
        observer.observe(el);
    }
});
